import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import { useDataState } from '../../../providers/DataProvider.hooks';
import ContentContainer from '../../common/ContentContainer';
import BlockHeader from '../../common/BlockHeader';
import Medal from './components/Medal';
import Cup from './components/Cup';

import { ReactComponent as GoldCup } from '../../../assets/clan/clanTrophies/icons/gold_cup.svg';
import { ReactComponent as SilverCup } from '../../../assets/clan/clanTrophies/icons/silver_cup.svg';
import { ReactComponent as BronzeCup } from '../../../assets/clan/clanTrophies/icons/bronze_cup.svg';
import { ReactComponent as GoldMedal } from '../../../assets/clan/clanTrophies/icons/gold_medal.svg';
import { ReactComponent as SilverMedal } from '../../../assets/clan/clanTrophies/icons/silver_medal.svg';
import { ReactComponent as BronzeMedal } from '../../../assets/clan/clanTrophies/icons/bronze_medal.svg';

export const ClanTrophies = () => {
    const { selectedClan, clansTournamentInfo } = useDataState();
    const clan = useMemo(() => {
        if (selectedClan && clansTournamentInfo) {
            return clansTournamentInfo.data.find((clan) => clan.name === selectedClan.clan);
        }
    }, [selectedClan, clansTournamentInfo]);

    return (
        <ContentContainer colorBg>
            <Box
                display={'flex'}
                justifyContent={'space-between'}
                sx={{
                    marginTop: '60px',
                    marginBottom: '20px',
                }}
            >
                <Box>
                    <BlockHeader text="Clan Trophies"></BlockHeader>
                </Box>
            </Box>
            <Box
                sx={{
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    padding: '30px',
                    marginBottom: '60px',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: '20px',
                        borderBottom: '1px solid #ECF0F4',
                        paddingBottom: '30px',
                    }}
                >
                    <Box display={'flex'} gap="15px" width={'100%'}>
                        <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                            <Typography
                                sx={{
                                    color: '#0F0E0E',
                                    fontFamily: 'AvenirNext600',
                                    fontSize: '20px',
                                }}
                            >
                                Tournament cups
                            </Typography>
                            <Typography
                                sx={{
                                    color: '#9298A1',
                                    fontFamily: 'AvenirNext400',
                                    fontSize: '16px',
                                }}
                            >
                                Earn cups for winning prizes in the final weekly{' '}
                                <span style={{ fontFamily: 'AvenirNext500', color: '#0F0E0E' }}>
                                    Clan Mastery Scoreboard
                                </span>
                            </Typography>
                        </Box>
                    </Box>
                    <Cup text="Gold cups" value={clan?.cups_gold} cupSvg={GoldCup} bgColor="#FDBB53"></Cup>
                    <Cup text="Silver cups" value={clan?.cups_silver} cupSvg={SilverCup} bgColor="#6E7379"></Cup>
                    <Cup text="Bronze cups" value={clan?.cups_bronze} cupSvg={BronzeCup} bgColor="#937544"></Cup>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        paddingTop: '30px',
                        gap: '20px',
                    }}
                >
                    <Box display={'flex'} gap="15px" width={'100%'}>
                        <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                            <Typography
                                sx={{
                                    color: '#0F0E0E',
                                    fontFamily: 'AvenirNext600',
                                    fontSize: '20px',
                                }}
                            >
                                Leaderboard medals
                            </Typography>
                            <Typography
                                sx={{
                                    color: '#9298A1',
                                    fontFamily: 'AvenirNext400',
                                    fontSize: '16px',
                                }}
                            >
                                Get medals for winning places in each of the three weekly{' '}
                                <span style={{ fontFamily: 'AvenirNext500', color: '#0F0E0E' }}>
                                    Purr-formance Charts
                                </span>
                            </Typography>
                        </Box>
                    </Box>
                    <Medal
                        text="Gold medals"
                        medals={{
                            isle: clan?.win_gold,
                            cup: clan?.winrate_gold,
                            wlkn: clan?.wlkn_gold,
                        }}
                        medalSvg={GoldMedal}
                        bgColor="#F47B04"
                    ></Medal>
                    <Medal
                        text="Silver medals"
                        medals={{
                            isle: clan?.win_silver,
                            cup: clan?.winrate_silver,
                            wlkn: clan?.wlkn_silver,
                        }}
                        medalSvg={SilverMedal}
                        bgColor="#6E7379"
                    ></Medal>
                    <Medal
                        text="Bronze medals"
                        medals={{
                            isle: clan?.win_bronze,
                            cup: clan?.winrate_bronze,
                            wlkn: clan?.wlkn_bronze,
                        }}
                        medalSvg={BronzeMedal}
                        bgColor="#937544"
                    ></Medal>
                </Box>
            </Box>
        </ContentContainer>
    );
};
